module.exports = __webpack_public_path__ + "img/logoIduam.d6f088b8.svg";